module.exports = __webpack_public_path__ + "media/images/plus-white-2722e851da26cbde30549e7589d61f13.svg";